export class StagingAccount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudAccountId",
            "baseName": "cloudAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StagingAccount.attributeTypeMap;
    }
    constructor() {
    }
}
